import useMountEffect from '@restart/hooks/useMountEffect';
import { RiPauseLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import actions from '@/actions';
import useActionCommand from '@/hooks/command/mavlink/useActionCommand';
import EventEmitter from '@/libs/EventEmitter';
import { NotifierService as notifier } from '@/libs/Notifier';
import { executeMavLinkCommand } from '@/utils/CommandUtils';

const Panel = ({ data: robots }) => {
  const dispatch = useDispatch();
  const actionCommand = useActionCommand();

  useMountEffect(() => {
    robots.forEach((robot) => process(robot));

    dispatch(actions.command.resetActivePanels());
  });

  //#region Process Functions
  const process = async (robot) => {
    try {
      await executeMavLinkCommand(robot, actionCommand.brakePX4Rover());

      onSuccess(robot);
    } catch (error) {
      onFailure(robot);
    }
  };
  //#endregion

  //#region Result Handlers
  const onSuccess = (robot) => {
    EventEmitter.publish(`${robot.id}/event/removeGoto`);

    notifier.success(`${robot.name} has been braked successfully.`);
  };

  const onFailure = (robot) => {
    notifier.error(`Failed to brake ${robot.name}.`);
  };
  //#endregion

  return null;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Brake';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiPauseLine;
Command.Panel = Panel;

export default Command;
